import(/* webpackMode: "eager", webpackExports: ["Loader"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Loader/Loader.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ClientHomeContent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/landing/HeroOptimized.module.css");
